import axios from "axios";
import axiosInstance from "../axiosConfig/instance";
import Swal from "sweetalert2";

export async function logoutfun() {
  try {
    const response = await axiosInstance.get("/v1/users/auth/logout");
    console.log(response);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshtoken");

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function profile() {
  try {
    const response = await axiosInstance.get("/v1/users/auth/profile");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function editProfile(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/auth/update-user-profile`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function refreshtoken() {
  try {
    // جلب الـ Refresh Token من localStorage أو من أي مكان مخزن فيه
    const refreshToken = localStorage.getItem("refreshtoken");
    if (!refreshToken) {
      throw new Error("No refresh token found.");
    }

    // إرسال الـ Refresh Token في الهيدر لطلب التوكن الجديد
    const response = await axiosInstance.post(
      "/v1/users/auth/refresh",
      {},
      {
        headers: {
          refresh_token: ` ${refreshToken}`, // إرسال الـ Refresh Token في الهيدر
        },
      }
    );

    // طباعة الاستجابة في الكونسول
    console.log(response);

    // تخزين التوكن الجديد في localStorage
    const newToken = response.data.token;
    localStorage.setItem("token", newToken);

    // إضافة التوكن الجديد إلى الهيدر
    axiosInstance.defaults.headers["Authorization"] = `Bearer ${newToken}`;

    return response;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error; // يمكنك معالجة الأخطاء بشكل مخصص هنا
  }
}
export async function changepasswordfun(changepassword) {
  try {
    const response = await axiosInstance.post(
      "/v1/clients/auth/user-change-password",
      changepassword
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log(error.response.data);
    return error.response.data;
  }
}

export async function contactus() {
  try {
    const response = await axiosInstance.get("/v1/users/contact-us");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function users(endpoint = "all-clients") {
  try {
    const response = await axiosInstance.get(`/v1/users/${endpoint}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function user(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/clients/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function owners() {
  try {
    const response = await axiosInstance.get("/v1/users/owners");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unit(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/units/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////////////Units////////////////////////////////
export async function units() {
  try {
    const response = await axiosInstance.get("/v1/users/units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function updateunit(formdata, id) {
  try {
    const response = await axios.post(
      `https://App.baskeg.com/api/v1/users/update-unit/${id}`,
      formdata,
      {
        headers: {
          Accept: "application/json",
          "api-key":
            "KpoKcXyjTCHxPquIyTLByode9ZioJ4NwRh4CAFwY5mgoOtw91iuda1Kh0duBaJkR",
          "Accept-Language": "en",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    console.error(
      "Error creating contract:",
      error.response?.data || error.message
    );
    return error; // Re-throw the error for further handling if needed
  }
}

export async function unitsPending() {
  try {
    const response = await axiosInstance.get("/v1/users/pending-units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsApproved() {
  try {
    const response = await axiosInstance.get("/v1/users/approved-units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsRejected() {
  try {
    const response = await axiosInstance.get("/v1/users/rejected-units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsArrivingsoon() {
  try {
    const response = await axiosInstance.get("/v1/users/arriving-soon-units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsCurrentlyhosting() {
  try {
    const response = await axiosInstance.get(
      "/v1/users/currently-hosting-units"
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsCheckingout() {
  try {
    const response = await axiosInstance.get("/v1/users/checking-out-units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function ownerdetail(id) {
  try {
    const response = await axiosInstance.get(`v1/users/owners/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function deleteunit(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/units/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////////////////Booking //////////////////////////////////////////
export async function booking() {
  try {
    const response = await axiosInstance.get("/v1/users/bookings");

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function bookingPending() {
  try {
    const response = await axiosInstance.get("/v1/users/pending-bookings");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function bookingApproved() {
  try {
    const response = await axiosInstance.get("/v1/users/approved-bookings");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function bookingRejected() {
  try {
    const response = await axiosInstance.get("/v1/users/rejected-bookings");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function deletebooking(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/bookings/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addBooking(formdata) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/bookings`,
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function updateBooking(formdata, id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-bookings/${id}`,
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}
////////////////////////////////////////contracts////////////////////////////////
export async function contract() {
  try {
    const response = await axiosInstance.get("/v1/users/contracts");
    console.log(response.data);

    Swal.fire("Contract Created");
    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function updatecontract(formdata, id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-contracts/${id}`,
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function createcontract(formdata, ownerid) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/contracts`,
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );

    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error(
      "Error creating contract:",
      error.response?.data || error.message
    );
    return error; // Re-throw the error for further handling if needed
  }
}

export async function deletecontract(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/contracts/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
//////////////////////////////////Service Request Methods////////////////////////////////

export async function servicereq() {
  try {
    const response = await axiosInstance.get("/v1/users/service-requests");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function createservicereq(formdata) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/service-requests`,
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );

    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error(
      "Error creating contract:",
      error.response?.data || error.message
    );
    return error; // Re-throw the error for further handling if needed
  }
}

export async function updateservicereq(id, form) {
  console.log(id);
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-service-requests/${id}`,
      form
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function delservicereq(id) {
  console.log(id);
  try {
    const response = await axiosInstance.post(
      `/v1/users/service-requests/${id}`
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////analysis/////////////////////////////////////////////

export async function analysistab() {
  try {
    const response = await axiosInstance.get("/v1/users/units-analysis-tab");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function analysis() {
  try {
    const response = await axiosInstance.get("/v1/users/units-analysis");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function owneranalysis() {
  try {
    const response = await axiosInstance.get("/v1/users/units-analysis-tab");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function brokeranalysis() {
  try {
    const response = await axiosInstance.get("/v1/users/brokers-analysis");
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function unitsanalysis() {
  try {
    const response = await axiosInstance.get("/v1/users/units");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Helpers////////////////////////////////

export async function unittypess() {
  try {
    const response = await axiosInstance.get("/v1/users/unit-types");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function createunit(formdata) {
  console.log(formdata);
  try {
    const response = await axiosInstance.post(`/v1/users/units`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the appropriate header
      },
    });

    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
    console.error(
      "Error creating contract:",
      error.response?.data || error.message
    );
    return error; // Re-throw the error for further handling if needed
  }
}
export async function placetype() {
  try {
    const response = await axiosInstance.get("/v1/users/place-types");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function broker() {
  try {
    const response = await axiosInstance.get("/v1/users/brokers");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function brokerid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/brokers/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addbrokers(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/brokers",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delbroker(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/brokers/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editbrokerr(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-brokers/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Edited");

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
/////////////////////////////Cancelation///////////////////////

export async function addCancelationReq(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/cancellation-requests`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function editCancelationReq(id, data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-cancellation-requests/${id}`,
      data
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function getCancelationReq() {
  try {
    const response = await axiosInstance.get(`v1/users/cancellation-requests`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function CancelationReq(id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/cancellation-requests`
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function delcancelationReq(id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/cancellation-requests/${id}`
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////////////////////////////////////////////////
export async function getbooking(id) {
  console.log(id);
  try {
    const response = await axiosInstance.get(`/v1/users/bookings/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function fetchservices() {
  try {
    const response = await axiosInstance.get(`/v1/users/maintenance-services`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function fetchmaintenance() {
  try {
    const response = await axiosInstance.get(`/v1/users/maintenance`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function editMaintenance(data, id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-maintenance/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function delmaintenance(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/maintenance/${id}`);
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function createmaintenancereq(form) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/maintenance`,
      form, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function fetchMaintenanceservice() {
  try {
    const response = await axiosInstance.get(`/v1/users/maintenance-services`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addMaintenanceservice(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/maintenance-services`,
      data
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function delMaintenanceservice(id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/maintenance-services/${id}`
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function getMaintenanceservice(id) {
  try {
    const response = await axiosInstance.get(
      `/v1/users/maintenance-services/${id}`
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function editMaintenanceservice(data, id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-maintenance-services/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////////////Banks //////////////////////////
export async function banks() {
  try {
    const response = await axiosInstance.get("/v1/users/banks");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function bankid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/banks/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createbank(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/banks",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delbank(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/banks/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editbank(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-banks/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Edited");

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Banks Account //////////////////////////
export async function banksaccount() {
  try {
    const response = await axiosInstance.get("/v1/users/bank-accounts");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function ownersbanksaccount() {
  try {
    const response = await axiosInstance.get("/v1/users/owners-bank-accounts");
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function bankaccountid(id) {
  console.log(id);
  try {
    const response = await axiosInstance.get(`/v1/users/bank-accounts/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createbankaccount(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/bank-accounts",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delbankaccount(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/bank-accounts/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editbankaccount(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-bank-accounts/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Edited");

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////////////Services //////////////////////////

export async function fetchservice() {
  try {
    const response = await axiosInstance.get(`/v1/users/services`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addservice(data) {
  try {
    const response = await axiosInstance.post(`/v1/users/services`, data);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function delservice(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/services/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function getservice(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/services/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function editservice(data, id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-services/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
///////////////PromoCode////////////////////////////////
export async function fetchPromo() {
  try {
    const response = await axiosInstance.get(`/v1/users/promo-codes`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addPromo(data) {
  try {
    const response = await axiosInstance.post(`/v1/users/promo-codes`, data);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function delPromo(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/promo-codes/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function getPromo(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/promo-codes/${id}`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function editPromo(id, data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-promo-codes/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
///////////////Social Media////////////////////////////////

export async function fetchSocialmedia() {
  try {
    const response = await axiosInstance.get(`v1/users/social-media`);
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addSocialmedia(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/social-media`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}
export async function delSocialmedia(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/social-media/${id}`);
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

////////////Settings//////////////////////////////////////////////////////
export async function fetchSettingType() {
  try {
    const response = await axiosInstance.get(`v1/users/settings-types`);
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function fetchSettings() {
  try {
    const response = await axiosInstance.get(`v1/users/settings`);
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addSetting(data) {
  try {
    const response = await axiosInstance.post(
      `v1/users/settings`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function editSetting(id, data) {
  try {
    const response = await axiosInstance.post(
      `v1/users/update-settings/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function delSetting(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/settings/${id}`);
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

///////////////////////////////Payment////////////////////////////////////

export async function fetchPayment() {
  try {
    const response = await axiosInstance.get(`/v1/users/payments`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
export async function payid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/payments/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function addPayment(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/payments`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}
///////////////////////////////SettingType////////////////////////////////////
export async function fetchsettingtype() {
  try {
    const response = await axiosInstance.get(`/v1/users/settings-types`);
    console.log(response.data.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addsettingtype(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/settings-types`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function delsettingtype(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/settings-types/${id}`);
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}
////////////////////////////////////////BrokerPayment//////////////////////////////////////////////////////

export async function fetchbrokerpayment() {
  try {
    const response = await axiosInstance.get(`/v1/users/brokers-payments`);
    console.log(response.data.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editbrokerpayment(id, data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-brokers-payments/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////////////////////////Notifcations//////////////////////////////////////////////////////
export async function addglobal(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/notifications/send`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function addowners(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/owners/notifications`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function addclients(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/clients/notifications`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function addclient(id, data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/notifications/client/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function addowner(id, data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/notifications/owner/${id}`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

////////////////////////////features //////////////////////////
export async function featuress() {
  try {
    const response = await axiosInstance.get("/v1/users/features");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function featuresid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/features/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createfeatures(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/features",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delfeatures(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/features/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editfeatures(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-features/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Refund //////////////////////////
export async function refunds() {
  try {
    const response = await axiosInstance.get("/v1/users/refund-requests");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createrefund(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/refund-requests",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delrefund(id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/refund-requests/${id}`
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editrefund(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-refund-requests/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////compounds //////////////////////////
export async function compound() {
  try {
    const response = await axiosInstance.get("/v1/users/compounds");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function compoundsid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/compounds/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createcompounds(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/compounds",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delcompounds(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/compounds/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editcompounds(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-compounds/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Edited");

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Unit Types//////////////////////////
export async function unittypes() {
  try {
    const response = await axiosInstance.get("/v1/users/unit-types");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function unittypesid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/unit-types/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createunittypes(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/unit-types",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delunittypes(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/unit-types/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editunittypes(id, formData) {
  console.log(id);
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-unit-types/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////countries//////////////////////////
export async function countries() {
  try {
    const response = await axiosInstance.get("/v1/users/countries");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function countryid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/countries/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createcountryy(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/countries",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delcountry(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/countries/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editcountry(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-countries/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////cities//////////////////////////
export async function cities() {
  try {
    const response = await axiosInstance.get("/v1/users/cities");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function cityid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/cities/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createcity(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/cities",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delcity(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/cities/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editcity(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-cities/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Unit Prices//////////////////////////
export async function unitprices() {
  try {
    const response = await axiosInstance.get("/v1/users/units-prices");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function unitpricesid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/units-prices/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createunitprices(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/units-prices",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delunitprices(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/units-prices/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editunitprices(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-units-prices/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

////////////////////////////place Types//////////////////////////
export async function placetypes() {
  try {
    const response = await axiosInstance.get("/v1/users/place-types");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function placetypesid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/place-types/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createplacetypes(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/place-types",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delplacetypes(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/place-types/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editplacetypes(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-place-types/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Identity Types//////////////////////////
export async function identitytypess() {
  try {
    const response = await axiosInstance.get("/v1/users/identity-types");
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}
export async function identitytypesid(id) {
  try {
    const response = await axiosInstance.get(`/v1/users/identity-types/${id}`);
    console.log(response);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function createidentitytypes(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/identity-types",
      formdata, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);
    Swal.fire("Broker Created");
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function delidentitytypes(id) {
  try {
    const response = await axiosInstance.post(`/v1/users/identity-types/${id}`);
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function editidentitytypes(id, formData) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/update-identity-types/${id}`,
      formData, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

////////////////////////////Chats//////////////////////////
export async function getallchats() {
  try {
    const response = await axiosInstance.get("/v1/users/admin-chats");
    console.log(response);

    return response.data.chats;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }

    return error;
  }
}

export async function sendmsg(formdata) {
  try {
    const response = await axiosInstance.post(
      "/v1/users/send-admin-message",
      formdata // FormData as the request body
    );
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    // if(error.message === "Request failed with status code 500"){
    //    Swal.fire("Broker already exists");
    // }

    return error;
  }
}
export async function receivemsg(id) {
  try {
    const response = await axiosInstance.get(
      `/v1/users/get-admin-messages/${id}`
    );
    console.log(response);

    return response.data.messages;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
////////////////////payment method////////////////////
export async function fetchpaymentmethods() {
  try {
    const response = await axiosInstance.get(`/v1/users/payment-methods`);
    console.log(response);

    return response.data.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}

export async function addpaymentmethod(data) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/payment-methods`,
      data, // FormData as the request body
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the appropriate header
        },
      }
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return error;
  }
}

export async function delpaymentmethod(id) {
  try {
    const response = await axiosInstance.post(
      `/v1/users/payment-methods/${id}`
    );
    console.log(response.data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.reload();
    }
  }
}
